module.exports = __webpack_public_path__ + "media/new/failure-icon-59331288.svg";